export default "__VITE_ASSET__C3E6rRst__"